
import publicUrl from '@/assets/js/interface'
import utils from '@/assets/js/utils'

const state = {
  coursesList: [],
  courseCatalog: [],
  courseActiveId: '',
  coursesInfo: {},
  finishCourse: {},
  classroomId: '',
  modelsDict: {
    'classroomJob': {
      'content': '',
      'jobType': '',
      'submitType': '',
      'tableStr': ''
    },
    'groupChat': {
      'content': '',
    },
    'questionnaire': {
      'content': '',
      'questions': [
        {
          'options': '',
          'order': 0,
          'questionStem': '',
          'questionnaireId': 0
        }
      ]
    },
    'resource': {
      'name': '',
      'resourceKey': '',
      'type': ''
    },
    'subjectDiscuss': {
      'content': '',
    },
    'test': {
      'content': '',
      'questionType': '',
      'questions': []
    },
    'text': {
      'content': '',
    },
  },
  modelsOnoff: {},
}

const getters = {
  coursesDict(state) {
    let result = {}
    state.coursesList.forEach(v => {
      v && (result[v.id] = v)
    })
    return result
  },
  courseActive(state, getters) {
    return getters.coursesDict[state.courseActiveId] || {}
  },
}

const mutations = {
  // 设置课程列表
  setCoursesList(state, params) {
    state.coursesList = params || []
  },
  // 设置课程详情 之前逻辑没敢动新加一个带分页的对象
  setCoursesInfo(state, params) {
    state.coursesInfo = params || []
  },
  // 设置课程目录
  setCourseCatalog(state, params) {
    state.courseCatalog = params || []
  },
  // 设置最近的课件
  setFinishCourse(state, params) {
    state.finishCourse = params || {}
  },
  // 设置当前课件id
  setCourseActiveId(state, params) {
    state.courseActiveId = parseInt(params)
  },
  // 设置当前上课id
  setClassroomId(state, params) {
    state.classroomId = parseInt(params)
  },

  setModelsOnoff(state, params) {
    let data = params.data || {}
    if (params.action === 'add') {
      state.modelsOnoff = {
        ...(state.modelsOnoff || {}),
        ...data
      }
    } else if (params.action === 'remove') {
      let modelsOnoff = utils.deepCopy(state.modelsOnoff)
      for (let k in data) {
        delete modelsOnoff[k]
      }
      state.modelsOnoff = modelsOnoff
    } else if (params.action === 'clear') {
      state.modelsOnoff = {}
    }
  },
}

const actions = {
  // params: {
  //   identity: '' 身份,
  //   searchCourseType: '' 查询模块类型 我的课程 标准课程 校内公开课程
  //   data: {} 参数
  // }
  // TEACHER("教师"), STUDENT("学生"), SCHOOL_MANAGER("校管"),
  // REDACT("编辑老师"), REVIEW_REDACT("审核编辑"), FINAL_REDACT("审核负责人");
  getCoursesList({ commit }, { vm, params }) {
    commit('setCoursesList', [])
    commit('setCoursesInfo', {})
    // params.type = params.type === 'PERSONAL' ? '' : params.type
    let apiUrl = publicUrl.myCourseList
    console.log("params.data=",params.data)
    if (params.searchCourseType === 'SCHOOL') { // 校内公开课程
      apiUrl = publicUrl.schoolOpenCourse
    } else if (params.searchCourseType === 'PUBLIC') { // 标准课程
      if (params.identity === 'TEACHER' ||params.identity === 'TEACHER_RESEARCH') {
        apiUrl = publicUrl.publicCourseList
      } else if (params.identity === 'SCHOOL_MANAGER') {
        apiUrl = publicUrl.publicCourseList
      } else if (params.identity === 'FINAL_REDACT') {
        apiUrl = publicUrl.publicCourseListCheckEditLeader
      } else if (params.identity === 'REVIEW_REDACT') {
        apiUrl = publicUrl.publicCourseListCheckEdit
      } else if (params.identity === 'REDACT') {
        apiUrl = publicUrl.publicCourseListEdit
      }

    } else if (params.searchCourseType === 'PERSONAL') { // 我的课程
      if (params.identity === 'REDACT') {
        apiUrl = publicUrl.publicCourseListEdit
      } else if (params.identity === 'STUDENT') {
        apiUrl = publicUrl.studentCourseList
      } else if (params.identity === 'TEACHER'||params.identity === 'TEACHER_RESEARCH') {
        apiUrl = publicUrl.myCourseList
      } else if (params.identity === 'SCHOOL_MANAGER') {
        apiUrl = publicUrl.myCourseList
      } else if (params.identity === 'REVIEW_REDACT') {
        apiUrl = publicUrl.publicCourseListCheckEdit
      } else if (params.identity === 'FINAL_REDACT') {
        apiUrl = publicUrl.publicCourseListCheckEditLeader
      }
    }else if (params.searchCourseType === 'DIG_RESOURCE'){
      if (params.data.resourceType === 'VIDEO'){
        apiUrl = publicUrl.videoCourseList
      }else{
        apiUrl = publicUrl.teachResourceList
      }

    }else if ( params.searchCourseType === 'TEACHER_BOOK'){
      apiUrl = publicUrl.bookList
      params.data.bookType='teacher'
    }else if (params.searchCourseType === 'STUDENT_BOOK'){
      apiUrl = publicUrl.bookList
       params.data.bookType='student'
    }
    return vm.$ajax.get(apiUrl, {
      params: { ...params.data }
    }).then(res => {
      if (res.data.code === 0) {
        commit('setCoursesList', res.data.data.result || [])
        commit('setCoursesInfo', res.data.data || {})
      } else {
        vm.$message.error(res.data.message)
      }
    }).catch(err => {
      vm.$ajaxError(err)
    })
  },
  getTextbookInfo({ state, commit }, { vm, bookId }) {
    return vm.$ajax.get(publicUrl.textbookInfo, {
      params: { bookId }
    }).then(res => {
      if (res.data.code === 0) {
        let data = res.data.data || {}
        // if (!getters.coursesDict[bookId]) {
        commit('setCoursesList', [...state.coursesList, data])
        // }
      } else {
        vm.$message.error(res.data.message)
      }
    }).catch(err => {
      vm.$ajaxError(err)
    })
  },
  getCourseCatalog({ commit }, { vm, textbookId }) {
    commit('setCourseCatalog', [])
    return vm.$ajax.get(publicUrl.courseCatalog, {
      params: { textbookId }
    }).then(res => {
      if (res.data.code === 0) {
        let courseCatalog = res.data.data || []
        commit('setCourseCatalog', courseCatalog)
      } else {
        vm.$message.error(res.data.message)
      }
    }).catch(err => {
      vm.$ajaxError(err)
    })
  },
  getFinishCourse({ commit }, { vm, classId, textbookId }) {
    if (isNaN(parseInt(classId))) {
      return Promise.reject('请先选择班级')
    }
    commit('setFinishCourse', {})
    return vm.$ajax.get(publicUrl.finishCourse, {
      params: { classId, textbookId }
    }).then(res => {
      if (res.data.code === 0) {
        let finishCourse = res.data.data || {}
        commit('setFinishCourse', finishCourse)
      } else {
        vm.$message.error(res.data.message)
      }
    }).catch(err => {
      vm.$ajaxError(err)
    })
  },
  classroomBegin({ state, rootState, rootGetters, commit }, { vm, jobId, projectId }) {
    return vm.$ajaxJson.post(publicUrl.classroomBegin, {
      classId: rootGetters['classmanagement/classActive'].id,
      courseId: state.courseActiveId,
      teacherId: rootState.userInfo.id,
      jobId, projectId
    }).then(res => {
      if (res.data.code === 0) {
        commit('setClassroomId', res.data.data)
        vm.$message.success('开课成功' || res.data.message)
      } else {
        vm.$message.error(res.data.message)
      }
    }).catch(err => {
      vm.$ajaxError(err)
    })
  },
  classroomEnd({ state }, { vm }) {
    return vm.$ajaxJson.post(publicUrl.classroomEnd, {
      id: state.classroomId
    }).then(res => {
      if (res.data.code === 0) {
        vm.$message.success('下课成功' || res.data.message)
      } else {
        vm.$message.error(res.data.message)
      }
    }).catch(err => {
      vm.$ajaxError(err)
    })
  },
  modelBegin({ rootGetters, commit }, { vm, modelId }) {
    let classId = rootGetters['classmanagement/classActive'].id
    return vm.$ajaxJson.post(publicUrl.modelBegin, {
      classId,
      modelId
    }).then(res => {
      if (res.data.code === 0) {
        commit('setModelsOnoff', {
          action: 'add',
          data: { [`${classId}_${modelId}`]: res.data.data }
        })
        vm.$message.success('模块开关开启成功' || res.data.message)
      } else {
        vm.$message.error(res.data.message)
      }
    }).catch(err => {
      vm.$ajaxError(err)
    })
  },
  modelEnd({ state, rootGetters, commit }, { vm, modelId }) {
    let classId = rootGetters['classmanagement/classActive'].id
    let id = state.modelsOnoff[`${classId}_${modelId}`]
    return vm.$ajaxJson.post(publicUrl.modelEnd, {
      id
    }).then(res => {
      if (res.data.code === 0) {
        commit('setModelsOnoff', {
          action: 'remove',
          data: { [`${classId}_${modelId}`]: false }
        })
        vm.$message.success('模块开关关闭成功' || res.data.message)
      } else {
        vm.$message.error(res.data.message)
      }
    }).catch(err => {
      vm.$ajaxError(err)
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
